import '@styles/vendors.scss';

import { Splide } from "@splidejs/splide";
window["Splide"] = Splide;